











































































































































































































































































































import Vue from "vue";
import ApiService from "@/services/ApiService";
import { MLFieldOptions } from "@/constants/ML";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
  name: "SingleMlModal",
  components: {
    // OrgSelectionAdmin,
    VueJsonPretty
  },
  data() {
    return {
      testRecipient: "",
      MLFieldOptionsObj: {},
      showSchoolFilter: false,
      showPreviewCount: false,
      loadingPreview: false,
      field: null,
      disabled: false,
      timeout: null,
      tagsAvailable: [
        { label: "Mani", value: "mani" },
        { label: "Pooya", value: "pooya" },
        { label: "Matt", value: "matt" },
        { label: "Denise", value: "denise" },
        { label: "Jenny", value: "jenny" },
      ],
      previewData: [],
      previewFields: [],
      availablePreviewFields: [],
      form: {
        name: "",
        estimator: null,
        tags: [],
        organization_ids: [],
        selection_type: false,
        query_json: [],
        description: "",
        limit_rows: null,
        selected_fields_json: [],
        weights_json: { "events.event": 1, test: 14 },
        extra_options: {
          repeating_field: null,
          frequency: null,
        },
        target_field: 'terms_archive_journeys.primary_transport_type'
      },
      validationRules: {
        name: [
          {
            required: true,
            message: "Please input Automation name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 80,
            message: "Length should be 3 to 80",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: false,
            message: "Please enter description",
            trigger: ["change", "blur"],
          },
        ],
        // rules: [
        //   {
        //     type: "date",
        //     required: true,
        //     message: "Please pick a date",
        //     trigger: "change",
        //   },
        // ],
      },
      loading: false,
      responseInfo: {
        status: null,
        // status: "finished",
        // total_processed: 3,
        // total_rows: 3,
        // skipped: 0,
        // filtered_schools: [1],
        // ignored_organization_ids: [5, 2],
        // total_ignored_users: [1, 3],
      },
      showJsonModal: false,
      jsonData: {}
    };
  },
  computed: {
    selectedField() {
      return "%" + this.field + "%";
    },
    fieldOptions() {
      return MLFieldOptions;
    },
  },
  props: {
    id: {
      type: Number || String,
      required: true,
    },
    isLaunchModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // "form.manual_trigger": function (newVal) {
    //   if (newVal) {
    //     this.form.when_to_launch = null;
    //   }
    // },
  },
  methods: {
    getPreviewData() {
      this.loadingPreview = true;
      this.$refs["ML_Form"].validate();
      const payload = {
        ...this.form,
        limit: this.limit ?? null,
      };
      ApiService.mlApi
        .previewData(payload)
        .then((resp) => {
          this.showPreviewCount = true;
          if (resp.data.length === 0) {
            // this.previewFields = [];

            this.previewData = [];
            return;
          }
          if (
            Object.keys(resp.data[0]).length !=
            this.availablePreviewFields.length
          ) {
            this.previewFields = Object.keys(resp.data[0]);
            this.availablePreviewFields = Object.keys(resp.data[0]);
          }
          this.previewData = resp.data;
        })
        .catch((e) => {
          this.$notify.error({
            title: "Error",
            message: e.response.data.error,
          });
        })
        .finally(() => {
          this.loadingPreview = false;
        });
    },
    // launch() {
    //   this.responseInfo = { status: null };
    //   const payload = {
    //     ...this.form,
    //   };
    //   ApiService.automationsApi
    //     .executeAutomation(payload)
    //     .then((resp) => {
    //       this.$notify.info({
    //         title: "Saved",
    //         message: "Good things just happened! You've triggered ML",
    //       });
    //       this.responseInfo = resp.data;
    //       // this.timeout = true;
    //       // this.timeout = setTimeout(() => {
    //       //   this.disabled = false;
    //       // }, 5000);
    //     })
    //     .catch((error) => alert(error));
    // },
    addRule() {
      this.form.query_json.push({
        comparison: "=",
      });
      this.$forceUpdate();
    },
    removeRule(index) {
      this.form.query_json.splice(index, 1);
    },
    closeModal() {
      this.close();
    },
    saveML(close, showNotice = true) {
      ApiService.mlApi.saveMlModel(this.form).then((resp) => {
        this.id = resp.data;

        if (showNotice) {
          this.$notify.info({
            title: "Saved",
            message: "Good things just happened!",
          });
        }

        if (close == true) {
          this.$emit("close");
        }
      });
    },
    formatTooltip(val) {
      return val / 100 + ' (' + val + '%)';
    },
    onSubmit() {
      this.$refs["ML_Form"].validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = {
          ...this.form,
        };
        if (this.id != 0) {
          payload.id = this.id;
        }

        this.saveML(false, false);

        setTimeout(() => {
          ApiService.mlApi.trainMl(this.id).then((resp) => {
            this.jsonData = resp.data;
            this.showJsonModal = true;
            this.$notify.success({
              title: "Testing finished",
              message: "Done!",
            });
          }).catch((e) => {
            this.$notify.error({
              title: "Error",
              message: e.response.data.error,
            });
          });
        }, 500)
      });
    },
    updateOrgIds(newValue) {
      this.form.organization_ids = newValue.organization_id;
    },
    close() {
      this.$emit("close");
    },
    async copyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$notify.info({
          title: "Copied",
        });
      } catch ($e) {
        alert("Cannot copy");
      }
    },
  },
  // beforeUnmount() {
  //   if (this.timeout) {
  //     clearTimeout(this.timeout);
  //   }
  // },
  mounted() {
    this.MLFieldOptionsObj = MLFieldOptions.reduce(
      (obj, cur) => ({ ...obj, [cur.value]: cur }),
      {}
    );
    if (this.id != 0) {
      ApiService.mlApi.getSingleMl(this.id).then((resp) => {
        const obj = resp.data;
        // this.form = obj;
        this.form.id = this.id;
        this.form.name = obj.name;
        this.form.estimator = obj.estimator;
        this.form.tags = obj.tags ? obj.tags : [];
        this.form.description = obj.description;
        // this.form.date = obj.date;
        this.form.holdout = obj.holdout;
        this.form.organization_ids = obj.organization_ids
          ? obj.organization_ids
          : [];
        // this.form.organization_ids = [];
        this.form.query_json = obj.query_json;
        this.form.selection_type =
          obj.selection_type == "BLACKLIST" ? true : false;
        // this.form.custom_rules = JSON.parse(obj.custom_rules);
        this.form.selected_fields_json = obj.selected_fields_json;
        this.form.target_field = obj.target_field;
        // this.form.extra_options = JSON.parse(obj.extra_options);
        this.$forceUpdate();
        this.showSchoolFilter = true;
      });
    }
    this.showSchoolFilter = true;
  },
});
